import React from 'react';
import { IAdminScreener, adminShareScreener } from '../../api/admin';
import ShareResourceDialog from './ShareResourceDialog';

interface Props {
	open: boolean;
	onClose: () => void;
	screeners: IAdminScreener[];
	sourceUserId: number;
}

export default function ShareScreenersDialog({ open, onClose, screeners, sourceUserId }: Props) {
	async function handleShare(
		itemIds: number[],
		targetUserIds: number[],
		newNames: Record<number, string>,
		overwrite: boolean,
		skipChecks: boolean,
	) {
		await Promise.all(
			itemIds.flatMap((id) => targetUserIds.map((uid) => adminShareScreener(id, uid, newNames[id], overwrite, skipChecks)))
		);
	}

	return (
		<ShareResourceDialog
			open={open}
			onClose={onClose}
			items={screeners}
			allowSkipChecks
			resourceLabel="screener"
			sourceUserId={sourceUserId}
			onShare={handleShare}
		/>
	);
}
